import React from 'react';
import { colors } from '../theme';
import IProps from './interface';

const IconNeutralFeedback = ({
  color = colors.darkYellow,
  size = 12,
}: Pick<IProps, 'size' | 'color'>) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 5.99988C1 3.23821 3.23833 0.999878 6 0.999878C8.76167 0.999878 11 3.23821 11 5.99988"
        stroke={color}
        strokeWidth="0.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 5.99988C11 8.76154 8.76167 10.9999 6 10.9999C3.23833 10.9999 1 8.76154 1 5.99988"
        stroke={color}
        strokeWidth="0.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.25 4.5V5"
        stroke={color}
        strokeWidth="0.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.75 4.5V5"
        stroke={color}
        strokeWidth="0.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.75 7.8C7.75 7.8 7.0935 7.8 6 7.8C4.906 7.8 4.25 7.8 4.25 7.8"
        stroke={color}
        strokeWidth="0.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IconNeutralFeedback;
